import { gql } from "@apollo/client";

export const UPDATE_FOLDER_GENERAL_INFO_MUTATION = gql`
  mutation updateFolderGeneralInfo($input: FolderGeneralInfoInput!) {
    updateFolderGeneralInfo(input: $input) {
      correlationId
    }
  }
`;

export const SAVE_NEW_FOLDER_MUTATION = gql`
  mutation saveNewFolder($input: SaveNewFolderInput!) {
    saveNewFolder(input: $input) {
      correlationId
    }
  }
`;

export const CALCULATE_APPROVAL_MUTATION = gql`
  mutation calculateApproval($input: CalculateApprovalInput!) {
    calculateApproval(input: $input) {
      correlationId
    }
  }
`;
